import { CmsApi } from './ApiConfig';

/**
 * CMS (Charging and Metering Service) API Client
 * Handles feature gating and billing plan configuration
 *
 * Base URL: http://localhost:8001 (CMS Service - Python FastAPI)
 */

const cmsApi = {
  /**
   * Get brand plan configuration including features and functions
   * @param {number} brandId - The brand ID to fetch configuration for
   * @returns {Promise} - Promise resolving to brand plan configuration
   */
  getBrandPlanConfiguration: async (brandId) => {
    try {
      const response = await CmsApi.get(
        `/api/v1/svc/cms/brand_plan_configuration/${brandId}`
      );
      return response.data;
    } catch (error) {
      console.error('[CMS Service] Failed to fetch brand plan configuration:', error);
      throw error;
    }
  },

  /**
   * Check if a specific action is allowed (pre-event validation)
   * Used before performing chargeable actions
   * @param {Object} params - Check limits parameters
   * @param {number} params.brandId - Brand ID
   * @param {number} params.functionId - Function ID
   * @param {number} params.quantity - Quantity to check
   * @param {string} params.category - Category (e.g., 'marketing')
   * @returns {Promise} - Promise resolving to limit check result
   */
  checkLimits: async ({ brandId, functionId, quantity, category }) => {
    try {
      const response = await CmsApi.post('/api/v1/svc/cms/check-limits', {
        brand_id: brandId,
        function_id: functionId,
        quantity,
        category,
      });
      return response.data;
    } catch (error) {
      console.error('[CMS Service] Failed to check limits:', error);
      throw error;
    }
  },
};

export { cmsApi };
export default cmsApi;
